import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const EmailTemplatesList = lazy(() => import("../../container/pages/emailTemplates/index"));

function EmailTemplatesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={EmailTemplatesList} />
    </Switch>
  );
}

export default EmailTemplatesRoute;
